// Where the Filter when popover sits on a wide screen: beside the funnel icon and a little above it, with the
// whole card kept inside the viewport. All numbers are pixels.

export const POPOVER_WIDTH = 440;
/** Space between the icon and the popover. */
const GAP = 12;
/** How far the popover's top sits above the icon's top. */
const RISE = 40;
/** Space kept clear at the viewport's edges. */
const MARGIN = 16;

export function filterPopoverPosition(
  icon: { top: number; right: number },
  viewport: { width: number; height: number },
  cardHeight: number,
): { left: number; top: number; maxHeight: number } {
  const besideIcon = icon.right + GAP;
  const lastLeftThatFits = viewport.width - POPOVER_WIDTH - MARGIN;
  const left = Math.max(MARGIN, Math.min(besideIcon, lastLeftThatFits));

  // A card taller than the viewport is capped to it and its body scrolls.
  const maxHeight = viewport.height - 2 * MARGIN;
  const shownHeight = Math.min(cardHeight, maxHeight);
  const aboveIcon = icon.top - RISE;
  const lastTopThatFits = viewport.height - MARGIN - shownHeight;
  const top = Math.max(MARGIN, Math.min(aboveIcon, lastTopThatFits));

  return { left, top, maxHeight };
}
